import { getUserDetailsFetchStatus } from '@/store/modules/userDataSlice';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

function useOnce(callback: () => void, flag = true) {
    //To delay the call based on below flag
    const isUserDetailsFetched = useSelector(getUserDetailsFetchStatus);
    const hasRun = useRef(false);

    useEffect(() => {
        if (flag && isUserDetailsFetched === 'yes' && !hasRun.current) {
            callback();
            hasRun.current = true;
        }
    }, [callback, flag, isUserDetailsFetched]);
}

export default useOnce;
